import table from '@/../public/i18n/portal-cta.json'
import { pickUiMessagesForSite, stripI18nUsage } from '@/components/shared/utils/uiMessages'

export function getPortalCtaMessages(localeCode) {
  return pickUiMessagesForSite(stripI18nUsage(table), localeCode)
}
